// extracted by mini-css-extract-plugin
module.exports = {"metricIconBadge":"metricIconBadge_metricIconBadge__2xJf0"};